import { convexClient, crossDomainClient } from '@convex-dev/better-auth/client/plugins'
import { env } from '@goaltree/env/web'
import { emailOTPClient, magicLinkClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: env.VITE_CONVEX_SITE_URL,
  plugins: [crossDomainClient(), convexClient(), magicLinkClient(), emailOTPClient()],
  // Don't re-fetch the session on every tab focus: it transiently drops Convex
  // auth to false, which flips isPro → skips quota queries and remounts vision
  // images (the "9/10 videos left" flicker + image reload on focus). Convex
  // still refreshes the access token on its own schedule.
  sessionOptions: { refetchOnWindowFocus: false },
})
